import API from 'utils/api';

import { SignUpTrialLength } from 'components/forms/constants';

import 'components/buttons/styles/button-google-sign-in.scss';

type ButtonGoogleSignInProps = {
  ctaVariation?: string,
  numSteps?: number,
  refPlanId?: string,
  trialLength?: number,
}

const ButtonGoogleSignIn = ({
  ctaVariation,
  numSteps,
  refPlanId,
  trialLength,
}:ButtonGoogleSignInProps) => {

  const handleClick = () => {
    window.posthog?.capture(
      'Sign up form submitted',
      {
        'Signed up with SSO': true,
        'SSO Type': 'Google',
        'CTA variation': ctaVariation,
        'CTA # of steps': numSteps,
      }
    );

    const refPlanIdProp = refPlanId || '';
    const trialLengthProp = trialLength || SignUpTrialLength.DEFAULT_TRIAL_LENGTH;

    API.googleSignup(refPlanIdProp, trialLengthProp).then(result => {
      if (result.data.url && window) {
        window.location = result.data.url;
      }
    });
  };

  return <button type="button" onClick={ handleClick } className="button-google-sign-in">
    <img src="https://marketing-assets.wheniwork-production.com/2023/06/22132659/google-g-icon.svg" role="presentation" />
    Start my free trial with Google
  </button>;
};

export default ButtonGoogleSignIn;